module.exports = __webpack_public_path__ + "static/media/pla_black_cocktail_straw1.77ee8720.png";